export default {
  ACTION: 'action',
  ASSIGNED_USER_IDS: 'assigned_user_ids',
  CAMERA_OPTION_TYPE: 'camera_option_type',
  CAMERA_SESSION_SRC: 'camera_session_src',
  CAMERA_STATE_API: 'camera_state_api',
  CAMERA_STATE_ASPECT: 'camera_state_aspect',
  CAMERA_STATE_FASTCAM: 'camera_state_fastcam',
  CAMERA_STATE_FLASH: 'camera_state_flash',
  CAMERA_STATE_LENS: 'camera_state_lens',
  CAMERA_STATE_OVERLAY_GRID: 'camera_state_overlay_grid',
  CAMERA_STATE_OVERLAY_LEVEL: 'camera_state_overlay_level',
  CAMERA_STATE_PIP_POSITION: 'camera_state_pip_position',
  CAMERA_STATE_PIP_STYLE: 'camera_state_pip_style',
  CAMERA_STATE_PIP: 'camera_state_pip',
  CAMERA_STATE_RESOLUTION: 'camera_state_resolution',
  CAMERA_STATE_SESSIONTAGS: 'camera_state_sessiontags',
  CAMERA_STATE_STAMP_DATETIME: 'camera_state_stamp_datetime',
  CAMERA_STATE_STAMP_LATLON: 'camera_state_stamp_latlon',
  CAMERA_STATE_VIDEO_RESOLUTION: 'camera_state_video_resolution',
  CANCEL_ABANDON_REASON: 'cancel_abandon_reason',
  CANCEL_REASON: 'cancel_reason',
  CONNECTIVITY_AVERAGE: 'connectivity_request_average',
  CONNECTIVITY_VARIANCE: 'connectivity_request_variance',
  CONNECTIVITY_NEW_STABILITY: 'connectivity_new_stability',
  CONNECTIVITY_OLD_STABILITY: 'connectivity_old_stability',
  CONNECTIVITY_OLD_STATUS: 'connectivity_old_status',
  CONNECTIVITY_NEW_STATUS: 'connectivity_new_status',
  CONNECTIVITY_REQUEST_TYPE: 'connectivity_request_type',
  COMMENTABLE: 'commentable',
  DEEP_LINK_SOURCE: 'deep_link_source',
  DID_MENTION: 'did_mention',
  DURATION_SECONDS: 'duration_seconds',
  EDITOR_ACTION_TYPE: 'editor_action_type',
  EDITOR_START_TYPE: 'editor_start_type',
  EVENT_ID: 'eventID',
  INTEGRATION_NAME: 'integration_name',
  LOCATION: 'location',
  MEDIA: 'media',
  NEW_TITLE: 'new_title',
  OLD_TITLE: 'old_title',
  PATH: 'path',
  PAYMENT_METHOD: 'payment_method',
  PHOTO_ORIENTATION: 'photo_orientation',
  PHOTOS_INCLUDED: 'photos_included',
  PHOTOS_PER_ROW: 'photos_per_row',
  PHOTO_DETAILS_INCLUDED: 'photo_details_included',
  PLAN_CYCLE_FROM: 'plan_cycle_from',
  PLAN_CYCLE_TO: 'plan_cycle_to',
  PLAN_TIER_FROM: 'plan_tier_from',
  PLAN_TIER_TO: 'plan_tier_to',
  PREV_PAYMENT_METHOD: 'prev_payment_method',
  PROJECT_ID: 'project_id',
  PROJECT_NAME: 'project_name',
  REGISTRATION_METHOD: 'registration_method',
  REGISTRATION_STEP: 'registration_step',
  REPORT_ID: 'report_id',
  REPORT_LAYOUT_NAME: 'report_layout_name',
  SAVE_TO_DOCS: 'save_to_docs',
  SCREEN: 'screen',
  SHARE_ORIGIN: 'share_origin',
  SOURCE: 'source',
  STARRABLE: 'starrable',
  STEP: 'step',
  SUBSCRIPTION_PLAN: 'subscription_plan',
  TAGGABLE: 'taggable',
  TASK_LIST_ID: 'task_list_id',
  TASK_LIST_TYPE: 'task_list_type',
  TEMPLATE_ID: 'template_id',
  TEMPLATE: 'template',
  VIDEO_ORIENTATION: 'video_orientation',
};
